// Handlers and state logic for AIChatBox
import { getEntities } from '../../API/Entity/Entity';
import { getEntityPages } from '../../API/Display/Display';
import { getProjectRelations } from "../Helpers/Schema/Schema";
import { getProjectRoles } from "../../API/Role/Role";
import { getPortals } from "../../API/Portal/Portal";
import { getAttributes } from '../../API/Attribute/Attribute';

// Example: handleExpandChange
export function handleExpandChange(setTreeOptions) {
    return function(event) {
        setTreeOptions(options => options.map(option => {
            if (option.id === event.item.id) {
                return {
                    ...option,
                    isExpanded: !option.isExpanded
                }
            }
            return option;
        }));
    }
}

export function handleSubTreeExpandChange(setSubTreeOptions) {
    return function(event) {
        setSubTreeOptions(options => options.map(option => {
            if (option.id === event.item.id) {
                return {
                    ...option,
                    isExpanded: !option.isExpanded
                }
            }
            return option;
        }));
    }
}

// More handlers (handleChange, handleSubTreeChange, handleMessage, etc.) can be moved here as needed, passing in state setters and dependencies as arguments.
// For brevity, only expand/collapse handlers are shown here. You can continue to modularize as needed.
